import React, { useState } from "react";
import { useReveal } from "./Hooks";
import {
  RevealWrapper,
  SectionContainer,
  SectionLabel,
  SectionTitle,
  SectionSubtitle,
  AgendaWrapper,
  AgendaBgBlob,
  AgendaContent,
  TimelineWrapper,
  AgendaItemWrapper,
  AgendaTime,
  AgendaTitle,
  AgendaDesc,
} from "../Styles";
import useWebinar from "../../../../hooks/useWebinar";

function AgendaItem({ time, icon, title, desc, delay }) {
  const { ref, visible } = useReveal(delay);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <RevealWrapper ref={ref} $visible={visible}>
      <AgendaItemWrapper
        $hovered={isHovered}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <AgendaTime>
          {icon && <span style={{ marginRight: "0.4rem" }}>{icon}</span>}
          {time}
        </AgendaTime>
        <AgendaTitle $hovered={isHovered}>{title}</AgendaTitle>
        <AgendaDesc>{desc}</AgendaDesc>
      </AgendaItemWrapper>
    </RevealWrapper>
  );
}

function Agenda() {
  const { config } = useWebinar();
  const agendaData = config?.agenda;

  const headingReveal = useReveal(0);
  const titleReveal = useReveal(80);
  const subtitleReveal = useReveal(140);

  if (!agendaData?.show) return null;

  const visibleItems = agendaData.items?.filter((item) => item.show) ?? [];

  return (
    <AgendaWrapper id="agenda">
      <AgendaBgBlob className="b1" aria-hidden="true" />
      <AgendaBgBlob className="b2" aria-hidden="true" />

      <SectionContainer>
        <AgendaContent>
          <RevealWrapper
            ref={headingReveal.ref}
            $visible={headingReveal.visible}
          >
            <SectionLabel $light>{agendaData.sectionLabel}</SectionLabel>
          </RevealWrapper>

          <RevealWrapper ref={titleReveal.ref} $visible={titleReveal.visible}>
            <SectionTitle $light>{agendaData.sectionTitle}</SectionTitle>
          </RevealWrapper>

          <RevealWrapper
            ref={subtitleReveal.ref}
            $visible={subtitleReveal.visible}
          >
            <SectionSubtitle $light>
              {agendaData.sectionSubtitle}
            </SectionSubtitle>
          </RevealWrapper>

          <TimelineWrapper>
            {visibleItems.map((item, index) => (
              <AgendaItem key={item.id} {...item} delay={index * 80} />
            ))}
          </TimelineWrapper>
        </AgendaContent>
      </SectionContainer>
    </AgendaWrapper>
  );
}

export { Agenda };
